import _DatabaseModel from "./_DatabaseModel";

const WAREHOUSES_TAB_BALANCE = 164;
const WAREHOUSES_TAB_EXTERNAL_GUIDS = 165;
const WAREHOUSES_TAB_TRANSACTIONS = 166;

class Warehouse extends _DatabaseModel {
  static model = "warehouse";
  static showSize = 8;
  static editDialogComponent = "warehouses-edit-dialog";

  static tableHeaders = [
    { textKey: "form.label.name", value: "name" },
    { text: "", value: "tags", sortable: false },
  ];

  static show = {
    buttons: ["edit"],
    reloadingModels: ["price_item_warehouse", "external_guid"],
  };

  static filter = {
    parts: {
      fields: ["name", "description", "time_filter"],
      extended_fields: ["connector_id"],
      time_filter: ["created_at", "updated_at"],
    },
  };

  static cardFields(object) {
    return {
      title: object.name,
      tags: true,
    };
  }

  static basicInfo(object) {
    return [
      {
        labelKey: "form.label.owner",
        value: object.owner?.person,
        type: "link",
        to: "persons",
      },
      {
        labelKey: "form.label.created_at",
        value: object.created_at,
        type: "date_time",
      },
    ];
  }

  static submenuActions = [
    this.commonActions.manageSubscriptions,
    this.commonActions.permittedPersons,
    this.commonActions.export,
    this.commonActions.openActivities,
    this.commonActions.delete,
  ];

  static tabs = [
    this.detailTab,
    {
      titleKey: "warehouse.label.balance",
      permission: WAREHOUSES_TAB_BALANCE,
      component: "WarehouseItemsTab",
      disabled: this.defaultDisabledTab(),
    },
    {
      titleKey: "warehouse.label.warehouse_transactions",
      permission: WAREHOUSES_TAB_TRANSACTIONS,
      component: "WarehouseTransactionTab",
      disabled: () => false,
    },
    {
      titleKey: "external_guid.external_guids",
      permission: WAREHOUSES_TAB_EXTERNAL_GUIDS,
      component: "ExternalGuidsTab",
      disabled: this.defaultDisabledTab(),
    },
  ];
}

export default Warehouse;
